// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import loadComponents from "gia/loadComponents";
// import config from "gia/config";

// ——————————————————————————————————————————— IMPORTS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// Global Modules //
import "./modules/globalInit.js";

// Init. fn() //
import { init_viewportState } from "./init/init_viewportState.js";
import init_collapsibles from "./init/init_collapsibles.js";

// Components //
import Nav from "../../../plugins/wel-all-widgets/widgets/nav/js/Nav.js";
import SectionScroller from "./comps/SectionScroller/SectionScroller";
import SlideShow from "./comps/SlideShow/SlideShow.js";
// import PopUp from "./comps/PopUp/PopUp.js";
import CollapsiblesList from "./comps/CollapsiblesList/CollapsiblesList.js";
import Marquee from "./comps/Marquee/Marquee.js";
import FloatingMedia from "../../../plugins/wel-all-widgets/widgets/floating-media/js/FloatingMedia.js";
import FormatCards from "../../../plugins/wel-all-widgets/widgets/format-cards/js/FormatCards.js";
import ProjectSlider from "../../../plugins/wel-all-widgets/widgets/project-slider/js/ProjectSlider.js";
import TeamSlider from "../../../plugins/wel-all-widgets/widgets/team-slider/js/TeamSlider.js";
import ImgMarquee from "../../../plugins/wel-all-widgets/widgets/img-marquee/js/ImgMarquee.js";
// import OrgaNetworkGraph from "../../../plugins/wel-all-widgets/widgets/orga-network-graph/js/OrgaNetworkGraph.js";
import OrgaNetworkGraphV2 from "../../../plugins/wel-all-widgets/widgets/orga-network-graph-v2/js/OrgaNetworkGraphV2.js";
import PopUp from "../../../plugins/wel-all-widgets/widgets/pop-up/js/PopUp.js";
const comps = {
  Nav: Nav,
  SectionScroller: SectionScroller,
  SlideShow: SlideShow,
  PopUp: PopUp,
  CollapsiblesList: CollapsiblesList,
  Marquee: Marquee,
  FloatingMedia: FloatingMedia,
  FormatCards: FormatCards,
  ProjectSlider: ProjectSlider,
  TeamSlider: TeamSlider,
  ImgMarquee: ImgMarquee,
  // OrgaNetworkGraph: OrgaNetworkGraph,
  OrgaNetworkGraphV2: OrgaNetworkGraphV2,
};

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import consoleStyles from "./assets/consoleStyles.js";

// ———————————————————————————————————————————— INIT. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

/////////////////////// Post DOM-content-loaded ////////////////////////
////////////////////////////////////////////////////////////////////////

document.addEventListener("DOMContentLoaded", () => {
  console.log("%cDOM content loaded...", consoleStyles.default);

  console.log("%cInit. viewport state...", consoleStyles.default);
  init_viewportState({
    breakpoints: { mob: 300, tblt_prt: 750, tblt_ls: 1000, desk_sm: 1170, desk_md: 1400 },
  });

  console.log("%cInit. collapsibles...", consoleStyles.default);
  init_collapsibles();

  console.log("%cLoading components...", consoleStyles.default);
  loadComponents(comps);

  console.log("%cApp initialized!", consoleStyles.success);
});
